




import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import Router from "./route/Router";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BeatLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { persistStore } from "redux-persist";
import './App.css';
import store from "./store";

const persistor = persistStore(store);

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<div className="loader-overlay">
        <BeatLoader color="#d79f36" />
      </div>}
        persistor={persistor}
        onBeforeLift={() => console.log("Redux state rehydrated!")}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <ToastContainer />
      </PersistGate>
    </Provider>
  );
}

export default App;
